import cookie from 'js-cookie';

// NOTE: This affiliate file is referred to as deprecated, although it is still in
// usage to determine the isAffiliate value in LaunchDarkly. In the future it might be replaced, see the comment below

// TODO: [aromanov] this affiliate integration will be deprecated and took down as soon as easy-marketing affiliates
// subsystem goes live. We will probably need to remove this code after that. Talk to payment team if you have questions

const REG_EXP = /[&#?]ref=((a|imp)\d+)/;

const COOKIE_NAME = 'jimdoRefAffiliate';

const TRS_COOKIE_NAME = 'trs';

const getAffiliateCodeFromUrl = () => {
  const match = (window.location.search || '').match(REG_EXP);
  if (!match) {
    return null;
  }

  return match[1];
};

const getAffiliateCodeFromCookie = () => {
  return cookie.get(COOKIE_NAME);
};

const getNewAffiliateCookie = () => {
  return cookie.get(TRS_COOKIE_NAME);
};

export const isAffiliate = () => {
  return Boolean(getAffiliateCodeFromUrl() || getAffiliateCodeFromCookie() || getNewAffiliateCookie());
};
